import React from "react";
import styles from './index.module.css';
import { StockfishIcon, LeelaIcon } from "../../assets";

const EngineCard = (props) => {

    return (
        <>
        <div className={`z-10 ${styles["card-wrapper"]}`} id="card-wrapper" tabindex="-1">
  <div className={`${styles["glow-card"]} ${styles["animated-gradient"]}`}>
    <div className={`${styles["inner"]}`}>
      <div className={`${styles["stats"]}`}>
        <div className={`${styles["wpm"]}`}>
          <b className={`${styles["big"]}`}>{props.type === 1 ? '1 Billion' : '500K'}</b>
          <small className={`${styles["small gray"]}`}>Node / Second</small>
        </div>
        <hr />
        <div className={`${styles["accuracy"]}`}>
          <b className={`${styles["big"]}`}>{props.type === 1 ? 'Stockfish 17' : 'Leelazero' }</b>
          <small className={`${styles["small gray"]}`}>{props.type === 1 ? 'nnue / classical' : 'Any Network' }</small>
        </div>
      </div>
      <div className={`${styles["restart"]}`}>
        <button id="restart">
          <i className={`${styles["fa-solid fa-arrow-rotate-right fa-2xl"]}`}></i>
        </button>
        <small className={`${styles["keys gray"]}`}>
        
        </small>
      </div>
    </div>
    {props.type === 1 && <img style={{left: 'calc(50% - 35px)'}} className="z-10 w-[70px] h-[82px] relative bottom-[100px]" src={StockfishIcon} />}
    {props.type === 2 && <LeelaIcon /> }
  </div>
</div>
</>
    )
}

export default EngineCard;